export type Effect = 'appear' | 'fade_in' | 'slide_in';

export default class CharacterCommandOptions {
  constructor(public effect?: Effect, public waiting?: boolean) {}
}
